<template>
  <v-tooltip bottom color="grey darken-3">
    <template v-slot:activator="{ on }">
      <v-icon small color="grey" dark v-on="on">{{icon}}</v-icon>
    </template>
    <span class="font-weight-medium">{{infoText}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: { infoText: String, icon: String }
}
</script>
